<template>
    <li class="modi_item">
        <span>{{ item.name }}</span> <SpinEdit v-model="value" :zerotext="pricetext" :nonzerotext="pricetext" :limit="spinlimit" :displaylimit="item.limit" :showlimit="item.limit > -1"/>
    </li>
</template>

<script>
import SpinEdit from './SpinEdit'

export default {
    data(){
        return {
            oldvalue: 0,
            value: 0
        }
    },
    computed:{
        modifier(){
            return {
                code: this.item.code,
                name: this.item.name,
                price: this.item.price,
                count: this.value,
                dt_cnt: this.value - this.oldvalue
            }
        },
        normlimit(){
            return (this.item.limit > -1) ? this.item.limit : 9999
        },
        normdisplaylimit(){
            return (this.item.limit > -1) ? this.item.limit : ' '
        },
        spinlimit(){
            return (this.limit - this.usedcount < this.normlimit - this.value) ? Math.abs(this.limit - Math.abs(this.usedcount - this.value)) : this.normlimit
        },
        pricetext(){
            return (this.changesprice == true) ? (this.item.price > 0) ? '+'+(this.item.price/100).toFixed(0) : '' : ''
        }
    },
    props:['item', 'limit', 'usedcount', 'changesprice'],
    watch:{
        value(){
            this.$emit('modi', this.modifier)
            this.oldvalue = this.value
        }
    },
    components:{
        SpinEdit
    },
    mounted(){
        this.oldvalue = 0
        this.value = 0
    }
}
</script>